import {toPixel} from 'admin-columns-js/helper/strings';

require( 'admin-columns-js/polyfill/nodelist' );

document.addEventListener( 'DOMContentLoaded', () => {
	let elements = document.querySelectorAll( '[data-ac-copy-clipboard]' );

	elements.forEach( ( el ) => {
		new CopyToClipboard( el );
	} );

} );

class CopyToClipboard {
	constructor( el, target ) {
		this.element = el;
		this.target = target;

		if ( !target ) {
			this.target = document.getElementById( this.element.dataset.acCopyClipboard );
		}

		this.element.addEventListener( 'click', ( e ) => {
			e.preventDefault();

			this.copyContent();
			this.feedback( e );
		} )
	}

	getContent() {
		return this.target.innerText;
	}

	copyContent() {
		let shadow_el = document.createElement( 'textarea' );
		let content = this.getContent();

		shadow_el.value = content;
		document.body.appendChild( shadow_el );
		shadow_el.select();
		document.execCommand( 'copy' );
		document.body.removeChild( shadow_el );

		return content;
	}

	feedback( e ) {
		let el = document.getElementById( 'ac-copy-page-feedback' );

		if ( !el ) {
			el = document.createElement( 'span' );
			document.body.appendChild( el );
		}

		el.id = 'ac-copy-page-feedback';
		el.innerText = 'Copied';
		el.style.top = toPixel( e.clientY + 15 );
		el.style.left = toPixel( e.clientX + 15 );

		setTimeout( () => {
			document.body.removeChild( el );
		}, 1500 );
	}

}